export default "__VITE_ASSET__DYHo0U6q__"